import { create } from 'zustand';

/**
 * Set while Selective Touch runs on a registered tablet (/tablet): the tablet
 * signed in as a device and a server unlocked it with their PIN. Selective
 * Touch then stays on /tablet, and Close locks the tablet back to the PIN pad
 * instead of leaving to the rest of the site.
 */
interface TabletState {
  active: boolean;
  lock: () => void;
  /** An API call was refused: 'device' means the tablet was revoked; anything else locks it. */
  onUnauthorized: (reason?: string) => void;
  setTablet: (active: boolean, lock?: () => void, onUnauthorized?: (reason?: string) => void) => void;
}

export const useTabletStore = create<TabletState>((set) => ({
  active: false,
  lock: () => {},
  onUnauthorized: () => {},
  setTablet: (active, lock, onUnauthorized) => set({ active, lock: lock ?? (() => {}), onUnauthorized: onUnauthorized ?? (() => {}) }),
}));

/** Where Selective Touch's own pages live: /tablet on a registered tablet, else /selective-touch. */
export function kioskBasePath(): string {
  return useTabletStore.getState().active ? '/tablet' : '/selective-touch';
}
